var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('card-panel',[_vm._t("default",null,{"action":_vm.openModal,"thumb":_vm.thumb})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }